export const blobToUrl = (blob: Blob) => {
    return URL.createObjectURL(blob);
};

export const extractUUIDFromURL = (url: string): string | null => {
    const regex = /\/images\/([^/]+)\/image$/;
    const matches = url.match(regex);

    if (matches && matches.length >= 2) {
        return matches[1];
    }

    return url;
};
